module.exports = __webpack_public_path__ + "static/media/apartment21.ebfe3aa9.jpg";